import { FilterOutlined } from "@ant-design/icons";

interface ClearFiltersButtonProps {
  onClear: () => void;
  className?: string;
}

export const ClearFiltersButton = ({
  onClear,
  className = "",
}: ClearFiltersButtonProps) => {
  return (
    <div className={`flex flex-col items-end gap-2 ${className}`}>
      <button
        type="button"
        className="flex justify-center text-sm cursor-pointer gap-2 text-gray-500"
        onClick={onClear}
      >
        <FilterOutlined className="text-base" />
        Limpiar filtros
      </button>
    </div>
  );
};